import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {HOME_PAGE_HOTEL_CARD_WIDTH} from '../constants'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${HOME_PAGE_HOTEL_CARD_WIDTH};
  flex-shrink: 0;
  height: 300px;
  overflow: hidden;
  background-color: ${cssTheme.colors.background.neutral.primary};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  cursor: pointer;
`

const ImageWrapper = styled.div`
  height: 156px;
`

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: ${cssTheme.layout.spacing.s400};
`

export const PriceDetailsSkeleton = () => (
  <SkeletonLoader width={86} align="right" marginTop={12} />
)

export const SuggestionHotelCardSkeleton = () => {
  return (
    <Wrapper>
      <ImageWrapper>
        <SkeletonLoader height="100%" />
      </ImageWrapper>
      <ContentContainer>
        <div>
          <SkeletonLoader width={139} />
          <SkeletonLoader width={90} />
        </div>
        <div>
          <SkeletonLoader width={56} align="right" />
          <PriceDetailsSkeleton />
        </div>
      </ContentContainer>
    </Wrapper>
  )
}
